const ACTIVE_MODULE_STATUSES = ['active', 'trial']
const activeTenantModulesCache = new Map()

export const normalizeTenantModuleKey = (moduleKey) => String(moduleKey || '')
    .trim()
    .toLowerCase()
    .replace(/-/g, '_')

const normalizeTenantKey = (tenantId) => String(tenantId || '').trim()

export function rememberTenantActiveModules(tenantId, modules) {
    const tenantKey = normalizeTenantKey(tenantId)

    if (!tenantKey || !Array.isArray(modules)) {
        return []
    }

    const activeModules = modules
        .map(normalizeTenantModuleKey)
        .filter(Boolean)

    activeTenantModulesCache.set(tenantKey, [...new Set(activeModules)])

    return cachedTenantActiveModules(tenantKey)
}

export function cachedTenantActiveModules(tenantId) {
    const tenantKey = normalizeTenantKey(tenantId)

    if (!tenantKey || !activeTenantModulesCache.has(tenantKey)) {
        return null
    }

    return [...activeTenantModulesCache.get(tenantKey)]
}

export function activeTenantModules(tenant) {
    if (!tenant) {
        return []
    }

    if (Array.isArray(tenant.active_modules)) {
        return tenant.active_modules
            .map(normalizeTenantModuleKey)
            .filter(Boolean)
    }

    if (Array.isArray(tenant.modules)) {
        return tenant.modules
            .filter((module) => ACTIVE_MODULE_STATUSES.includes(String(module?.status || '').toLowerCase()))
            .map((module) => normalizeTenantModuleKey(module?.module_key))
            .filter(Boolean)
    }

    return []
}

export function tenantHasModule(tenant, moduleKey) {
    const normalizedModuleKey = normalizeTenantModuleKey(moduleKey)

    if (!normalizedModuleKey) {
        return true
    }

    return activeTenantModules(tenant).includes(normalizedModuleKey)
}
